export default __webpack_public_path__ + "static/chroma-h-78652b0b5c78d69ad5534b84ec92be85.jpg";